import './App.css';
import Profile from './Components/Profile';

function App() {
  return (
    <Profile/>
  );
}

export default App;
